import AbstractAnimation from "./abstract-animation";
import {Sine} from "gsap";

export default class CloseAccordion extends AbstractAnimation
{
    create(): any {
        return this
            .timeline
            .to(this.$element, 0.2, { height: 0, ease: 'power3.easeIn' })
            .call(() => this
                .$element
                .attr('hidden', 'hidden')
            )
            .set(this.$element, { clearProps: 'all' })
        ;
    }
}